<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="`/empresa/desafios/${$route.params.id}/tarefas`"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de tarefas do desafio"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode lançar uma nova tarefa para os colaboradores
              participantes do desafio. A data de inicío e o deadline controlam
              o período em que a tarefa aceitará respostas.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0 vld-parent" ref="desafio_container">
                <i class="fas fa-clipboard-list mr-1"></i>
                Tarefa do desafio
              </h3>
            </div>
            <div class="card-body vld-parent" ref="task_container">
              <div class="row">
                <div class="col-lg-6">
                  <base-input label="Título da tarefa*">
                    <textarea
                      rows="1"
                      class="form-control form-control"
                      placeholder="Digite aqui..."
                      v-model="model.task.title"
                    >
                    </textarea>
                  </base-input>
                </div>
                <div class="col-lg-6 text-center text-lg-left">
                  <base-input label="Tarefa ativa?">
                    <br />
                    <base-switch
                      v-bind:value="model.task.active"
                      @input="isActiveChangeHandler($event)"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Data de início*</label>
                    <base-input
                      type="date"
                      placeholder="Data de início"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.start_date"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Deadline*</label>
                    <base-input
                      type="date"
                      placeholder="Deadline"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.end_date"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 tf-container-edditable">
                  <base-input label="Descrição da tarefa*">
                    <quill-editor
                      v-model="model.task.description"
                      :options="editorEdittableDescription"
                    >
                    </quill-editor>
                  </base-input>
                </div>
                <div class="col-lg-6 tf-container-edditable">
                  <base-input label="Instruções para a submissão*">
                    <quill-editor
                      v-model="model.task.submit_instruction"
                      :options="editorEdittableInstructions"
                    >
                    </quill-editor>
                  </base-input>
                </div>
              </div>
              <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{ error }}</base-alert>
              </div>
              <base-button
                type="primary"
                @click="handleSubmitTask()"
                class="mt-1 float-right"
                :disabled="!isValidModel"
              >
                Criar tarefa
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tarefas_form",
  components: {
    quillEditor
  },
  data() {
    return {
      model: {
        task: {
          title: "",
          start_date: "",
          end_date: "",
          description: "",
          submit_instruction: "",
          active: true
        }
      },
      taskStatus: [
        {
          key: "visible",
          value: "Visível",
          description:
            "Uma tarefa visível pode ser vista pelos colaboradores do desafio, que podem realizar a submissão de suas respostas caso a data atual respeite a data de início e o deadline da tarefa."
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma tarefa invisível fica oculta para todos os colaboradores, não aparecendo nem mesmo em seu histórico."
        }
      ],
      editorEdittableDescription: {
        placeholder:
          "Descreva a tarefa (lembre-se, se necessário, você pode linkar arquivos pelo editor)"
      },
      editorEdittableInstructions: {
        placeholder:
          "Digite aqui os detalhes sobre o que o colaborador deve enviar (lembre-se, se necessário, você pode linkar arquivos pelo editor)"
      },
      batch: "",
      error: ""
    };
  },
  async mounted() {},
  methods: {
    async handleSubmitTask() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.task_container,
        width: 90,
        height: 90
      });
      try {
        const task = this.model.task;
        await api.post(
          `/company/challenges/${this.$route.params.id}/tasks`,
          task
        );
        this.$toasted.show("Tarefa cadastrada com sucesso");
        this.$router.push(`/empresa/desafios/${this.$route.params.id}/tarefas`);
      } catch (e) {
        const strError = "Ocorreu um erro ao criar a tarefa. Tente novamente.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
    isActiveChangeHandler(event) {
      if (typeof event === "boolean") this.model.task.active = event;
    }
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.taskStatus.find(
        status => status.key === this.model.task.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
    isValidModel() {
      const requiredFields = [
        "title",
        "end_date",
        "start_date",
        "description",
        "submit_instruction"
      ];
      for (const key of requiredFields) {
        if (this.model.task[key] === "") return false;
      }
      return true;
    }
  }
};
</script>
<style>
.tf-container-edditable .quill-editor .ql-container,
.tf-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
